import * as Sentry from "@sentry/react";
import ReactDOM from "react-dom";

import App from "./App";
import "./index.css";
import "./styles/data-table.css";
import "./config/i18_init";
import { CarProvider } from "./contexts/CarContext";
import { ToastProvider } from "./contexts/ToastContext";
import { UserProvider } from "./contexts/UserContext/UserContext";

// Benign browser warning when ResizeObserver callbacks affect layout in the same frame.
// Prevents CRA dev overlay from treating it as a fatal runtime error.
const suppressResizeObserverLoopError = (event) => {
    if (
        event?.message === "ResizeObserver loop completed with undelivered notifications." ||
        event?.message === "ResizeObserver loop limit exceeded"
    ) {
        event.stopImmediatePropagation();
    }
};
window.addEventListener("error", suppressResizeObserverLoopError);

Sentry.init({
    dsn: process.env.REACT_APP_CENTRY_DSN,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    // Add optional integrations for additional features
    integrations: [
        Sentry.replayIntegration({
            // NOTE: This will disable built-in masking. Only use this if your site has no sensitive data, or if you've already set up other options for masking or blocking relevant data, such as 'ignore', 'block', 'mask' and 'maskFn'.
            maskAllText: false,
            blockAllMedia: false,
        }),
    ],

    // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
    tracesSampleRate: 1,
    // Enable logs to be sent to Sentry
    enableLogs: true,

    // Define how likely Replay events are sampled.
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,

    // Define how likely Replay events are sampled when an error occurs.
    replaysOnErrorSampleRate: 1.0,

    // Setting this option to true will print useful information to the console while you're setting up Sentry.
    debug: false,
});

ReactDOM.render(
    <ToastProvider>
        <UserProvider>
            <CarProvider>
                <App />
            </CarProvider>
        </UserProvider>
    </ToastProvider>,
    document.getElementById("root"),
);
